import React, { useCallback } from 'react';

import { Box, Button, Popover, Typography } from '@mui/material';
import PopTipCDS from '@sharedCR/coreDesignSystem/PopTipCDS';
import PropTypes from 'prop-types';

import { defaultPopoverOptions } from 'constants/popover';

import {
  buttonStyles,
  descriptionStyles,
  itemTextWrapperStyles,
  popoverContentStyles,
  popoverWrapperStyles,
} from './MenuPopoverCDS.styles';

const popoverOptions = {
  vertical: 'top',
  horizontal: 'right',
};

const MenuPopoverCDS = ({ anchorEl = null, onClose, items, ...props }) => {
  const onClickItemButton = useCallback(
    callback =>
      (...args) => {
        onClose();
        callback?.(...args);
      },
    [onClose],
  );

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={defaultPopoverOptions.anchorOrigin}
      open={!!anchorEl}
      sx={popoverWrapperStyles}
      transformOrigin={popoverOptions}
      onClose={onClose}
      {...props}
    >
      <Box sx={popoverContentStyles}>
        {items.map(({ text, description, isDisabled, onClick, icon, disableTooltip, ...props }) => {
          const button = (
            <Button
              disableRipple
              disabled={isDisabled}
              key={text}
              startIcon={icon}
              sx={buttonStyles}
              type="button"
              onClick={onClickItemButton(onClick)}
              {...props}
            >
              <Box sx={itemTextWrapperStyles}>
                <Typography variant="regular16">{text}</Typography>
                {description && (
                  <Typography color="text.secondary" sx={descriptionStyles} variant="regular12">
                    {description}
                  </Typography>
                )}
              </Box>
            </Button>
          );

          // Wrap disabled buttons with tooltips in a span and PopTipCDS
          if (isDisabled && disableTooltip) {
            return (
              <PopTipCDS key={text} title={disableTooltip}>
                <span>{button}</span>
              </PopTipCDS>
            );
          }

          return button;
        })}
      </Box>
    </Popover>
  );
};

MenuPopoverCDS.propTypes = {
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.instanceOf(Element),
};

export default MenuPopoverCDS;
